export default "__VITE_ASSET__02b54e33__"